import { Tokens } from './tokens';

export enum SupportedChains {
    ARBITRUM_ONE = 42161,
    ARBITRUM_NITRO = 421613,
    POLYGON = 137,
    BINANCE_SMART_CHAIN = 56,
    DEV = 13579,
    GOERLI = 5,
}

export type EnabledChains = [SupportedChains.ARBITRUM_ONE];

export type ChainInfo = Record<
    SupportedChains,
    {
        name: string;
        label: string;
        nativeCurrency: {
            name: string;
            symbol: Tokens;
            decimals: number;
        };
        rpcUrls: string[];
        blockExplorer?: string;
    }
>;

// Order of chains will determine order shown in header
export const CHAIN_INFO: ChainInfo = {
    [SupportedChains.ARBITRUM_ONE]: {
        name: 'Arbitrum One',
        label: 'Arbitrum',
        nativeCurrency: { name: 'Ether', symbol: Tokens.ETH, decimals: 18 },
        blockExplorer: 'https://arbiscan.io',
        rpcUrls: [
            'https://arbitrum-one-rpc.publicnode.com',
            // process.env.NODE_ENV === 'development'
            //     ? 'https://arb-mainnet.g.alchemy.com/v2/-PbH4F-527FLQJiMOIf8x7PVl56tGHuz'
            //     : `https://${process.env.REACT_APP_PROVIDER_ARBITRUM_ONE}`,
        ],
    },
    [SupportedChains.ARBITRUM_NITRO]: {
        name: 'Arbitrum Nitro Rollup Testnet',
        label: 'Testnet',
        nativeCurrency: { name: 'Ether', symbol: Tokens.ETH, decimals: 18 },
        blockExplorer: 'https://goerli.arbiscan.io',
        rpcUrls: [
            process.env.NODE_ENV === 'development'
                ? 'https://goerli-rollup.arbitrum.io/rpc'
                : 'https://rough-fragrant-log.arbitrum-goerli.quiknode.pro/b65cd5edd5569b9893e2ae334a5017e13420e8cf/',
        ],
    },
    [SupportedChains.POLYGON]: {
        name: 'Polygon',
        label: 'Polygon',
        nativeCurrency: { name: 'Matic Token', symbol: Tokens.MATIC, decimals: 18 },
        blockExplorer: 'https://polygonscan.com',
        rpcUrls: ['https://polygon-rpc.com/'],
    },
    [SupportedChains.BINANCE_SMART_CHAIN]: {
        name: 'Binance Smart Chain',
        label: 'BSC',
        nativeCurrency: { name: 'BNB ', symbol: Tokens.BNB, decimals: 18 },
        blockExplorer: 'https://bscscan.com',
        rpcUrls: ['https://bscrpc.com'],
    },
    [SupportedChains.DEV]: {
        name: 'Unlimimted Testnet',
        label: 'Testnet',
        nativeCurrency: { name: 'Ether', symbol: Tokens.ETH, decimals: 18 },
        blockExplorer: 'http://localhost:8545',
        rpcUrls: ['http://localhost:8545'],
    },
    [SupportedChains.GOERLI]: {
        name: 'Goerli Test Network',
        label: 'Goerli',
        nativeCurrency: { name: 'Goerli Ether', symbol: Tokens.GOERLI_ETH, decimals: 18 },
        blockExplorer: 'https://goerli.etherscan.io',
        rpcUrls: ['https://cloudflare-eth.com/v1/goerli'],
    },
};
